import styled from 'styled-components';

export const CategoryLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  
  .label { font-size: 14px; color: #666; }
  .value { font-size: 14px; font-weight: 600; color: #1a1a1a; }
`;

// Style objects for inline styles
export const marginStyles = {
  mb16: { marginBottom: 16 },
  mt16: { marginTop: 16 }
};
